const BUCKET = 'app-public-assets';
const FOLDER = 'calendar';

/**
 * 학년도 달력(2월~다음해 2월) → public/calendar/calendar2~14 인덱스.
 * - academicYear년 2~12월 → 2~12
 * - academicYear+1년 1월 → 13
 * - academicYear+1년 2월 → 14
 */
export function dashboardMonthCalendarArtIndex(
  academicYear: number,
  year: number,
  month: number
): number | null {
  const y = Math.floor(academicYear);
  if (!Number.isFinite(y) || y <= 0) return null;
  if (year === y && month >= 2 && month <= 12) return month;
  if (year === y + 1 && month === 1) return 13;
  if (year === y + 1 && month === 2) return 14;
  return null;
}

function artFileName(index: number): string {
  return `calendar${index}.webp`;
}

/** 예전 Storage 공개 URL — 로컬 파일이 없을 때만 폴백 */
export function dashboardMonthCalendarArtStorageUrl(index: number): string | null {
  const base = (process.env.REACT_APP_SUPABASE_URL || '').trim().replace(/\/$/, '');
  if (!base) return null;
  return `${base}/storage/v1/object/public/${BUCKET}/${FOLDER}/${artFileName(index)}`;
}

/** 버셀·로컬 동일 출처 */
export function dashboardMonthCalendarArtLocalUrl(index: number): string {
  return `/calendar/${artFileName(index)}`;
}

/** 우선순위: 버셀 public/calendar → Storage 폴백 */
export function dashboardMonthCalendarArtUrl(index: number): string {
  return dashboardMonthCalendarArtLocalUrl(index);
}

export function dashboardMonthCalendarArtFallbackUrl(index: number): string {
  return dashboardMonthCalendarArtStorageUrl(index) ?? dashboardMonthCalendarArtLocalUrl(index);
}
